import { render, staticRenderFns } from "./upload_single.vue?vue&type=template&id=ebd010dc&scoped=true"
import script from "./upload_single.vue?vue&type=script&lang=js"
export * from "./upload_single.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd010dc",
  null
  
)

export default component.exports